export enum CompanyAbnQuestion {
  Number = "ABN_COMPANY_NUMBER",
  BusinessDescription = "ABN_BUSINESS_DESCRIPTION",
  BusinessAddress = "ABN_BUSINESS_ADDRESS",
  BusinessActivity = "ABN_BUSINESS_ACTIVITY",
  // GST-specific questions
  BusinessGSTRegistration = "ABN_BUSINESS_GST_REGISTRATION",
  GSTTurnover = "ABN_GST_TURNOVER",
  GSTLodgementFrequency = "ABN_GST_LODGEMENT_FREQUENCY",
  GSTCashAccounting = "ABN_GST_CASH_ACCOUNTING",
  GSTImportsGoods = "ABN_GST_IMPORTS_GOODS",

  BusinessJurisdiction = "ABN_BUSINESS_JURISDICTION",
  AgriculturalOperations = "ABN_AGRICULTURAL_OPERATIONS",
}

export const COMPANY_ABN_FIELD_TO_PATH: Record<CompanyAbnQuestion, string> = {
  [CompanyAbnQuestion.Number]: "number",
  [CompanyAbnQuestion.BusinessDescription]: "business-description",
  [CompanyAbnQuestion.BusinessAddress]: "business-address",
  [CompanyAbnQuestion.BusinessActivity]: "business-activity",
  // Add paths for new questions
  [CompanyAbnQuestion.BusinessGSTRegistration]: "business-gst-registration",
  [CompanyAbnQuestion.GSTTurnover]: "gst-turnover",
  [CompanyAbnQuestion.GSTLodgementFrequency]: "gst-lodgement-frequency",
  [CompanyAbnQuestion.GSTCashAccounting]: "gst-cash-accounting",
  [CompanyAbnQuestion.GSTImportsGoods]: "gst-imports-goods",

  [CompanyAbnQuestion.BusinessJurisdiction]: "business-jurisdiction",
  [CompanyAbnQuestion.AgriculturalOperations]: "agricultural-operations",
};
